"use strict";

angular.module("vendor")
.controller("QuickBooksRevokeController", function($scope, QUICKBOOKS) {
    $scope.QuickBooksGuideURL = QUICKBOOKS.INTEGRATION_GUIDE_URL;
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/integration/quickbooks/quickbooks-revoke.controller.js
// module id = 1023
// module chunks = 0